// @flow
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Select from 'react-select/lib/Select'

const SelectInput = (props) => {
  const handleOnchange = (value) => {
    if (value !== null) {
      props.onChange(value)
    }
  }

  const classes = ['react-select']

  return (
    <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-middle">
      <div className="col-10 col-sm-3 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right">
        <label htmlFor={props.id}>{props.label}</label>
      </div>
      <div className="col-12 col-sm-8 order-3 order-sm-0 offset-sm-1 mt-2 pr-sm-0">
        <div className="d-block">
          <div className={classNames(classes)}>
            <Select
              id={props.id}
              name={props.name}
              onChange={handleOnchange}
              options={props.options}
              searchable={props.searchable}
              value={props.value}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

SelectInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  searchable: PropTypes.boolean,
  tooltip: PropTypes.node,
  tooltipLabel: PropTypes.string,
  value: PropTypes.string,
}

SelectInput.defaultProps = {
  className: 'react-select',
  label: '',
  name: '',
  onChange: () => null,
  options: [],
  searchable: true,
  tooltip: null,
  tooltipLabel: '',
  value: '',
}

export default SelectInput
